import Cookies from 'js-cookie';

export default {
  getSessionId() {
    return Cookies.get('PHPSESSID', { domain: '.hiworks.com' });
  },
  getOfficeId() {
    return Cookies.get('h_officeid', { domain: '.hiworks.com' });
  },
};
